import React from 'react';

const BannerUpcoming = (props) => (
  <section id="banner" className="style2">
    <div className="inner">
      <header className="major">
        <h1>Upcoming Publications</h1>
      </header>
      <div className="content">
        <p>A list of upcoming publications and deadlines.</p>
      </div>
    </div>
  </section>
);

export default BannerUpcoming;
